import axios from 'axios';

const client = () =>
{
    let defaultOptions = {};
    return {
        get: (url, options = {}) => axios.get(url, { ...defaultOptions, ...options }),
        post(url, params, options = {})
        {
            let formData = false;
            for (var key in params)
            {
                if (typeof params[key] === 'Object')
                {
                    formData = true;
                }
            }

            if (formData)
            {
                defaultOptions = {
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                };

                const data = new FormData();
                for (var key in params)
                {
                    if (typeof params[key] === 'Object')
                    {
                        data.append(key, params[key], params[key].name);
                    }
                    else
                    {
                        data.append(key, params[key]);
                    }
                }
                return axios.post(url, data, { ...defaultOptions, ...options });
            }
            return axios.post(url, params, { ...defaultOptions, ...options });
        },
        put: (url, data, options = {}) => axios.put(url, data, { ...defaultOptions, ...options }),
        delete: (url, options = {}) => axios.delete(url, { ...defaultOptions, ...options }),
    };
};

export default client();
